import React, {FC, useEffect, useState} from "react";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import OrderDetailsTab from "./OrderDetailsTab";
import FinishingTab from "./FinishingTabs";
import "../order.css";
import PropertyDetailTab from "./section/PropertyDetailTab";
import ButtonTray from "../../../components/common/form/ButtonTray";
import {FaFileExcel, FaFileImport} from "react-icons/fa";
import ImportData from "../modal/ImportData";
import OrderSpreadSheetImportModel from "../modal/OrderSpreadSheetImportModel";

const CreateOrder: FC = () => {

    interface TabProps {
        isActive: boolean;
        label: string;
    }

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Orders", url: "/orders"},
        {content: "Add Order", url: "/orders/create"},
    ]);

    const [tab, setTab] = useState(1);
    const [createOrderData, setCreateOrderData] = useState<any>({
        orderNumber: "",
        customerId: "",
        branchId: "",
        sellers: [],
        buyers: [],
        properties: [],
        note: ""
    });


    useEffect(() => {
        document.title = "Create Order";
    });

    const Tab: FC<TabProps> = ({isActive, label}) => (
        <div
            className={`col-span-4 order_tab_outer sm:mt-3 md:mt-0 mt-3 ${isActive ? "bg-highlight-0 active_tab" : "inactive_tab"}`}>
            <h3 className="text-text-0 py-2 px-6 relative">{label}</h3>
        </div>
    );

    return (
        <div className="px-5 py-5">
            <Breadcrumb crumbs={crumbs}/>

            <div className="flex justify-center mt-3">
                <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                    <div className="gap-4 grid-cols-12 sm:block md:grid pb-4 border-b border-surface-5">
                        <Tab isActive={tab === 1} label="Add Order"/>
                        <Tab isActive={tab === 2} label="Add Property"/>
                        <Tab isActive={tab === 3} label="Finishing Up"/>
                    </div>

                    {tab === 1 &&
                        <div className={'d-flex justify-end gap-3'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            modal: (
                                                <OrderSpreadSheetImportModel
                                                    show={true}
                                                    setShow={() => {
                                                    }}
                                                />
                                            ),
                                            onOpen: () => {
                                            },
                                            triggerButton: (
                                                <FaFileExcel className={"fa-2xl text-highlight-0"}/>
                                            ),
                                        },
                                        buttonType: "modal",
                                    },
                                    {
                                        buttonProps: {
                                            modal: (
                                                <ImportData
                                                    show={true}
                                                    setShow={() => {
                                                    }}
                                                    setCreateOrderData={setCreateOrderData}
                                                />
                                            ),
                                            onOpen: () => {
                                            },
                                            triggerButton: (
                                                <FaFileImport className={"fa-2xl text-highlight-0"}/>
                                            ),
                                        },
                                        buttonType: "modal",
                                    }
                                ]}/>

                        </div>
                    }

                    {/* Order tab */}
                    {
                        tab === 1 && <OrderDetailsTab setTab={setTab} createOrderData={createOrderData}
                                                      setCreateOrderData={setCreateOrderData}/>
                    }
                    {/* Package tab */}
                    {
                        tab === 2 &&
                        <PropertyDetailTab setTab={setTab}
                                           createOrderData={createOrderData}
                                           setCreateOrderData={setCreateOrderData}
                        />
                    }

                    {/* Finishing tab */}
                    {
                        tab === 3 && <FinishingTab setTab={setTab} createOrderData={createOrderData}
                                                   setCreateOrderData={setCreateOrderData}/>
                    }
                </div>
            </div>
        </div>
    );
};

export default CreateOrder;
